import { useAuth } from 'hooks'
import { Permission } from 'utils/constants'

const usePermission = () => {
  const { user } = useAuth()

  const hasPermission = (key: Permission): boolean =>
    user.permissions?.includes(key) ?? false

  return { hasPermission }
}

export default usePermission
